(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbBetslipLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbBetslipLib"] = factory();
	else
		root["sbBetslipLib"] = factory();
})(window, function() {
return 